import { TChatInListSchema } from '../../types/chatList';
import { ITypedReduxAction } from '../../types/redux/actionType';

export enum EArchivedListActionTypes {
  SetPending = 'chats/archivedList/setPending',
  SetSucceed = 'chats/archivedList/setSucceed',
  SetFailed = 'chats/archivedList/setFailed',
}

export interface IArchivedListRequest {
  // timestamp последнего чата, последней страницы
  timestampArchive?: number;
}

export type TArchivedListPayload = TChatInListSchema[];

export type TArchivedListActions =
  | ITypedReduxAction<EArchivedListActionTypes.SetPending, IArchivedListRequest>
  | ITypedReduxAction<EArchivedListActionTypes.SetSucceed, TArchivedListPayload>
  | ITypedReduxAction<EArchivedListActionTypes.SetFailed, void>;
